import {
  GET_TAXES_KEY_TOKEN_ERROR,
  GET_TAXES_KEY_USER_ERROR,
  GET_TAXES_KEY_USER_SUCCESS
} from '../TaxesKeyAuth/TaxesKeyAuth.actions'
import {
  GET_TOKEN_ERROR,
  GET_UNIQUE_PASS_RECOVERY_INFO_ERROR,
  GET_UNIQUE_PASS_RECOVERY_INFO_SUCCESS,
  GET_USER_INFO_SUCCESS
} from '../UniquePassAuth/UniquePassAuth.actions'
import {
  ASSOCIATE_ADMIN,
  ASSOCIATE_ADMIN_ERROR,
  ASSOCIATE_ADMIN_SUCCESS,
  CHECK_GUEST_BUSINESS,
  CHECK_GUEST_BUSINESS_ERROR,
  CHECK_GUEST_BUSINESS_SUCCESS,
  CLEAN_GUEST_BUSINESS_ERRORS_SUCCESS,
  CLEAN_GUEST_BUSINESS_SUCCESS,
  CREATE_SELLER,
  CREATE_SELLER_ERROR,
  CREATE_SELLER_SUCCESS,
  CREATE_TEMPORARY_SELLER,
  CREATE_TEMPORARY_SELLER_AREAS_ERROR,
  CREATE_TEMPORARY_SELLER_AREAS,
  CREATE_TEMPORARY_SELLER_ERROR,
  CREATE_TEMPORARY_SELLER_SUCCESS,
  GET_COUNTRIES,
  GET_COUNTRIES_ERROR,
  GET_COUNTRIES_SUCCESS,
  GET_GUEST_BUSINESS_AREAS,
  GET_GUEST_BUSINESS_AREAS_ERROR,
  GET_GUEST_BUSINESS_AREAS_SUCCESS,
  GET_GUEST_BUSINESS_DISTRICTS,
  GET_GUEST_BUSINESS_DISTRICTS_ERROR,
  GET_GUEST_BUSINESS_DISTRICTS_SUCCESS,
  GET_GUEST_BUSINESS_OPTIONS,
  GET_GUEST_BUSINESS_OPTIONS_ERROR,
  GET_GUEST_BUSINESS_OPTIONS_SUCCESS,
  GET_GUEST_FULL_NAME,
  GET_GUEST_FULL_NAME_ERROR,
  GET_GUEST_FULL_NAME_SUCCESS,
  RECOVER_ADMIN,
  RECOVER_ADMIN_ERROR,
  RESEND_REGISTRATION_EMAIL,
  RESEND_REGISTRATION_EMAIL_ERROR,
  RESEND_REGISTRATION_EMAIL_SUCCESS,
  RESET_REGISTER_WIZARD_STATE,
  RESET_SEND_REGISTRATION_EMAIL,
  REGISTER_CODE_VALIDATION,
  REGISTER_CODE_VALIDATION_ERROR,
  REGISTER_CODE_VALIDATION_SUCCESS,
  SAVE_TEMPORARY_PERSONAL_INFORMATION,
  SEND_REGISTRATION_EMAIL,
  SEND_REGISTRATION_EMAIL_ERROR,
  SEND_REGISTRATION_EMAIL_SUCCESS,
  SET_FOREIGN_REGISTRATION,
  SET_REGISTER_TYPE,
  UPDATE_REGISTRATION_INFORMATION,
  UPDATE_REGISTRATION_INFORMATION_ERROR,
  UPDATE_REGISTRATION_INFORMATION_SUCCESS,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_ERROR,
  UPDATE_PASSWORD_SUCCESS,
  VALIDATE_DNI,
  VALIDATE_DNI_SUCCESS,
  VALIDATE_DNI_ERROR,
  GET_AFFIDAVIT,
  GET_AFFIDAVIT_ERROR,
  GET_AFFIDAVIT_SUCCESS,
  OPEN_CONFIRM_NEW_AFFIDAVIT_DIALOG,
  CLOSE_CONFIRM_NEW_AFFIDAVIT_DIALOG,
  GET_SELLER_BLOCKED_INFO,
  GET_SELLER_BLOCKED_INFO_ERROR,
  GET_SELLER_BLOCKED_INFO_SUCCESS
} from './RegisterWizard.actions'

const registerWizardState = {
  business: { loading: false },
  countries: [],
  emailVerify: {
    code: '',
    codeIsValid: undefined,
    emailSent: false,
    errorSendingEmail: false
  },
  error: false,
  errors: {
    businessInformationError: null,
    businessSearchError: null,
    dniError: null,
    recoveryError: null,
    affidavitError: null
  },
  guest: {},
  affidavit: { loading: false },
  identityDoesNotMatch: false,
  isRecoveryAdmin: false,
  isValidDocument: false,
  isTaxesKey: false,
  isUniquePass: false,
  loading: false,
  registerType: '',
  confirmNewAffidavitDialogState: {
    draft: false,
    error: undefined,
    loading: false,
    open: false
  },
  blockedInfo: { error: null, dateBlocked: '', isBlocked: false, loading: false, reason: '' }
}

/**
 * The register wizard's reducer.
 */
const registerWizardReducer = (state = registerWizardState, { payload, type }) => {
  switch (type) {
    case GET_GUEST_FULL_NAME:
    case VALIDATE_DNI:
    case UPDATE_PASSWORD:
    case UPDATE_REGISTRATION_INFORMATION: {
      return { ...state, error: false, loading: true }
    }
    case GET_GUEST_FULL_NAME_ERROR: {
      return {
        ...state,
        errors: { ...state.errors, dniError: payload.reason },
        loading: false,
        error: true,
        guest: { ...state.guest, dni: payload.dni }
      }
    }
    case GET_GUEST_FULL_NAME_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          dni: payload.dni,
          firstLastName: payload.firstLastName,
          gender: payload.gender,
          name: payload.name,
          secondLastName: payload.secondLastName
        }
      }
    }
    case VALIDATE_DNI_SUCCESS: {
      return { ...state, loading: false }
    }
    case VALIDATE_DNI_ERROR: {
      return { ...state, errors: { ...state.errors, dniError: payload.reason }, loading: false, error: true }
    }
    case SAVE_TEMPORARY_PERSONAL_INFORMATION: {
      return {
        ...state,
        guest: {
          ...state.guest,
          country: payload.country,
          firstLastName: payload.firstLastName,
          gender: payload.gender,
          identificationNumber: payload.identificationNumber,
          isForeign: payload.isForeign,
          name: payload.name,
          phone: payload.phone,
          phoneCode: payload.phoneCode,
          secondLastName: payload.secondLastName
        }
      }
    }
    case RESET_REGISTER_WIZARD_STATE: {
      return registerWizardState
    }
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          dni: payload.dni,
          name: payload.name,
          firstLastName: payload.firstLastName,
          secondLastName: payload.secondLastName,
          phone: payload.phone,
          gender: payload.gender
        },
        isUniquePass: true
      }
    }
    case RESEND_REGISTRATION_EMAIL:
    case SEND_REGISTRATION_EMAIL: {
      return {
        ...state,
        error: false,
        loading: true,
        emailVerify: {
          ...state.emailVerify,
          emailSent: false,
          errorSendingEmail: undefined,
          sendingEmail: true
        }
      }
    }
    case SEND_REGISTRATION_EMAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          id: payload.id,
          email: payload.email
        },
        emailVerify: {
          ...state.emailVerify,
          code: payload.code,
          emailSent: true,
          errorSendingEmail: false,
          sendingEmail: false
        }
      }
    }
    case RESEND_REGISTRATION_EMAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        emailVerify: {
          ...state.emailVerify,
          code: payload.code,
          emailSent: true,
          errorSendingEmail: false,
          sendingEmail: false
        }
      }
    }
    case RESEND_REGISTRATION_EMAIL_ERROR:
    case SEND_REGISTRATION_EMAIL_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        emailVerify: {
          ...state.emailVerify,
          emailSent: false,
          errorSendingEmail: true,
          sendingEmail: false
        }
      }
    }
    case REGISTER_CODE_VALIDATION: {
      return {
        ...state,
        error: false,
        loading: true,
        emailVerify: { ...state.emailVerify, codeIsValid: undefined }
      }
    }
    case REGISTER_CODE_VALIDATION_ERROR: {
      return {
        ...state,
        error: true,
        loading: false,
        emailVerify: { ...state.emailVerify, codeIsValid: false }
      }
    }
    case REGISTER_CODE_VALIDATION_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        emailVerify: { ...state.emailVerify, codeIsValid: true }
      }
    }
    case RESET_SEND_REGISTRATION_EMAIL: {
      return { ...state, emailVerify: registerWizardState.emailVerify }
    }
    case SET_REGISTER_TYPE: {
      return { ...state, registerType: payload }
    }
    case CHECK_GUEST_BUSINESS: {
      return {
        ...state,
        business: { ...registerWizardState.business, dni: payload.dni },
        errors: { businessSearchError: registerWizardState.errors.businessSearchError },
        loading: true
      }
    }
    case CHECK_GUEST_BUSINESS_ERROR: {
      return { ...state, errors: { businessSearchError: payload.reason }, loading: false }
    }
    case CHECK_GUEST_BUSINESS_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, ...payload },
        loading: false
      }
    }
    case CLEAN_GUEST_BUSINESS_ERRORS_SUCCESS: {
      return { ...state, errors: registerWizardState.errors }
    }
    case CREATE_TEMPORARY_SELLER:
    case CREATE_TEMPORARY_SELLER_AREAS:
    case CREATE_SELLER: {
      return { ...state, errors: registerWizardState.errors, loading: true }
    }
    case CREATE_TEMPORARY_SELLER_ERROR: {
      return {
        ...state,
        errors: { ...state.errors, businessInformationError: payload.reason },
        loading: false
      }
    }
    case CREATE_TEMPORARY_SELLER_AREAS_ERROR:
    case CREATE_SELLER_ERROR: {
      return { ...state, loading: false }
    }
    case GET_GUEST_BUSINESS_OPTIONS: {
      return {
        ...state,
        business: { ...state.business, loading: true }
      }
    }
    case GET_GUEST_BUSINESS_OPTIONS_ERROR: {
      return {
        ...state,
        business: { ...state.business, loading: false }
      }
    }
    case GET_GUEST_BUSINESS_OPTIONS_SUCCESS: {
      return {
        ...state,
        business: {
          ...state.business,
          address: payload.address,
          district: payload.district,
          incomeBracket: payload.incomeBracket,
          incomeBrackets: payload.incomeBrackets,
          incomeYear: payload.incomeYear,
          loading: false,
          size: payload.size,
          state: payload.state,
          states: payload.states,
          type: payload.type
        }
      }
    }
    case GET_GUEST_BUSINESS_DISTRICTS: {
      return {
        ...state,
        business: { ...state.business, districtLoading: true }
      }
    }
    case GET_GUEST_BUSINESS_DISTRICTS_ERROR: {
      return {
        ...state,
        business: { ...state.business, districtLoading: false }
      }
    }
    case GET_GUEST_BUSINESS_DISTRICTS_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, districts: payload.districts, districtLoading: false }
      }
    }
    case CREATE_TEMPORARY_SELLER_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, id: payload.id },
        loading: false
      }
    }
    case CREATE_SELLER_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, id: payload.id, url: payload.url, username: payload.username },
        loading: false
      }
    }
    case CLEAN_GUEST_BUSINESS_SUCCESS: {
      return {
        ...state,
        business: registerWizardState.business,
        errors: { businessSearchError: registerWizardState.errors.businessSearchError }
      }
    }
    case GET_GUEST_BUSINESS_AREAS: {
      return {
        ...state,
        business: {
          ...state.business,
          loading: true
        }
      }
    }
    case GET_GUEST_BUSINESS_AREAS_ERROR: {
      return {
        ...state,
        business: {
          ...state.business,
          loading: false
        },
        errors: { businessAreasError: 'SOMETHING_WENT_WRONG_ERROR' }
      }
    }
    case GET_GUEST_BUSINESS_AREAS_SUCCESS: {
      return {
        ...state,
        business: {
          ...state.business,
          areas: payload.areas,
          loading: false
        }
      }
    }
    case UPDATE_PASSWORD_SUCCESS:
    case UPDATE_REGISTRATION_INFORMATION_SUCCESS: {
      return { ...state, error: false, loading: false }
    }
    case UPDATE_PASSWORD_ERROR:
    case UPDATE_REGISTRATION_INFORMATION_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case GET_UNIQUE_PASS_RECOVERY_INFO_ERROR: {
      return {
        ...payload.backup,
        errors: { businessSearchError: payload.reason }
      }
    }
    case GET_TOKEN_ERROR:
    case GET_TAXES_KEY_TOKEN_ERROR:
    case GET_TAXES_KEY_USER_ERROR: {
      return {
        ...payload.backup,
        errors: { businessSearchError: payload.reason }
      }
    }
    case GET_TAXES_KEY_USER_SUCCESS:
    case GET_UNIQUE_PASS_RECOVERY_INFO_SUCCESS: {
      return {
        ...payload.backup,
        business: { ...payload.backup.business, loading: false, name: payload.name }
      }
    }
    case SET_FOREIGN_REGISTRATION: {
      return {
        ...state,
        guest: {
          ...state.guest,
          isForeign: payload
        }
      }
    }
    case GET_COUNTRIES: {
      return {
        ...state,
        business: { ...state.business, loading: true },
        loading: true
      }
    }
    case GET_COUNTRIES_ERROR: {
      return {
        ...state,
        business: { ...state.business, loading: false },
        loading: false
      }
    }
    case GET_COUNTRIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        business: { ...state.business, loading: false },
        countries: payload.countries
      }
    }
    case ASSOCIATE_ADMIN:
    case RECOVER_ADMIN: {
      return {
        ...state,
        isRecoveryAdmin: true,
        loading: true
      }
    }
    case ASSOCIATE_ADMIN_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, loading: false },
        loading: false
      }
    }
    case ASSOCIATE_ADMIN_ERROR:
    case RECOVER_ADMIN_ERROR: {
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, recoveryError: payload.reason }
      }
    }
    case GET_AFFIDAVIT: {
      return {
        ...state,
        affidavit: { ...state.affidavit, loading: true }
      }
    }
    case GET_AFFIDAVIT_ERROR: {
      return {
        ...state,
        errors: { ...state.errors, affidavitError: payload.reason },
        affidavit: { ...state.affidavit, loading: false }
      }
    }
    case GET_AFFIDAVIT_SUCCESS: {
      return { ...state, affidavit: { ...payload.affidavit, loading: false } }
    }
    case OPEN_CONFIRM_NEW_AFFIDAVIT_DIALOG: {
      return {
        ...state,
        confirmNewAffidavitDialogState: {
          draft: false,
          error: undefined,
          loading: false,
          open: true
        }
      }
    }
    case CLOSE_CONFIRM_NEW_AFFIDAVIT_DIALOG: {
      return {
        ...state,
        confirmNewAffidavitDialogState: {
          draft: false,
          error: undefined,
          loading: false,
          open: false
        }
      }
    }
    case GET_SELLER_BLOCKED_INFO: {
      return {
        ...state,
        blockedInfo: { ...state.blockedInfo, error: null, loading: true },
        error: registerWizardState.error,
        errors: registerWizardState.errors
      }
    }
    case GET_SELLER_BLOCKED_INFO_ERROR: {
      return {
        ...state,
        blockedInfo: { ...state.blockedInfo, error: payload.error, loading: false }
      }
    }
    case GET_SELLER_BLOCKED_INFO_SUCCESS: {
      return {
        ...state,
        blockedInfo: {
          ...state.blockedInfo,
          dateBlocked: payload.dateBlocked,
          isBlocked: payload.isBlocked,
          loading: false,
          reason: payload.reason
        }
      }
    }
    default: {
      return state
    }
  }
}

export default registerWizardReducer
